
import SettingActions from './SettingActions'

export default {
    name: 'Setting',
    components: { SettingActions },
    props: {
        component: {
            type: null,
            default: null
        },
        hasActions: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            title: '',
            desc: '',
            state: 'show',
            showAlert: false,
            alertData: {
                type: 'success',
                head: '',
                body: ''
            }
        }
    },
    methods: {
        setInfo (info) {
            this.title = info.title
            this.desc = info.desc
        },
        alert ({ type, head, body, time }) {
            this.alertData = { type, head, body }
            this.showAlert = true

            if (time !== 0) {
                setTimeout(() => {
                    this.showAlert = false
                }, time || 5000)
            }
        },
        edit () {
            this.state = 'edit'
        },
        reset () {
            this.state = 'show'
        },
        submit () {
            this.state = 'submit'
        },
        submitted () {
            this.state = 'show'
        }
    }
}
